<template>
    <div>
      <div class="popup-info popup-icon-info">
          <svg style="height: 48px;">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#trash2"></use>
          </svg>

          <div class="text mt24">
              <div class="text-size-l text-bold info-title">Удалить договор?</div>

              <p class="info-text mt16">
                  Это действие нельзя отменить.
              </p>
          </div>

          <div class="mt24">
              <submit-btn @click.native="remove" :type="btnType"><span class="i i-ok7 mr8"></span>Подтвердить</submit-btn>
          </div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue'

    export default {
        name: "RemoveContract",
        components: {
            SubmitBtn
        },
        data() {
            return {
                btnType: 'normal',
            }
        },
        props: {
        },
        methods: {
            remove(){
                this.btnType = 'load';
                this.$store.dispatch('contracts/deleteContract',{id:this.$route.params.id}).then((item)=>{
                    this.btnType = 'normal';
                    this.$router.push('/staff/contract/'+this.$route.params.sid+'/');
                    this.$store.commit('popups/close', {name: this.popups.removeContract.name});
                })
            },
            close: function () {
                this.$store.commit('popups/close', {name: this.popups.removeContract.name});
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
            }),
        }
    }
</script>

<style scoped>

</style>
